// extracted by mini-css-extract-plugin
export default {"root":"PickDuration_root__6JsYt","limit":"PickDuration_limit__tEZU0","limitLabel":"PickDuration_limitLabel__K+Ytk"};